import { reactNode } from '@shared/node-v1.0.0'

import v010 from '@nodes/tooltip-v0.1.0'

export default reactNode(
	'Tooltip',
	{
		'v0.1.0': v010,
	},
	{ allowChildren: true, docs: '' }
)
